import React from 'react';
import {
  Container,Card, Modal,
  Box, CircularProgress,
  Typography, Divider,
  Button, FormControl,
  Paper, InputBase,
  IconButton, Switch
} from '@material-ui/core';
import {
  Share as ShareIcon,
  CardGiftcard as GiftIcon,
  WorkOutline as WorkshopIcon
} from '@material-ui/icons';
import { withStyles } from '@material-ui/core/styles';

import GameTopPanel from '../../component/game/user_interface/gameTopPanel';
import FooterPanel from '../../component/game/user_interface/gameFooterPanel';

import dndBanner from '../../element/2026/dndbanner.png'
import {GET_JAMBUILDER_BY_ID} from '../../api/graphql'
import { DUPLICATE_GAME } from '../../api/graphql-mutation';
import { withApollo } from 'react-apollo';
import { getUserId } from '../../utility/function';

const styles = theme => ({
  root: {
    backgroundColor: '#f5f5f5',
    minHeight: '100vh'
  },
  headerBannerOnly:{
    width: '100%',
    //height: '200px', 
    overflow: 'hidden',
    //borderRadius: '8px', 
    //marginBottom: '12px' 
  },
  headerBanner: {
    background: 'linear-gradient(135deg, #f5e6d3 0%, #f5d0a9 25%, #f5b380 50%, #f59e6c 75%, #f58b5c 100%)',
    padding: '40px 20px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative'
  },
  headerContent: {
    textAlign: 'center',
    maxWidth: '800px'
  },
  featuredText: {
    color: '#6b4423',
    fontSize: '14px',
    fontWeight: 500,
    marginBottom: '8px',
    letterSpacing: '0.5px'
  },
  mainTitle: {
    color: 'white',
    fontSize: '48px',
    fontWeight: 700,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '16px'
  },
  giftIcon: {
    fontSize: '48px',
    color: '#8b5a3c'
  },
  contentContainer: {
    padding: '40px 20px'
  },
  pageHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: '24px'
  },
  titleSection: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px'
  },
  workshopIcon: {
    fontSize: '24px',
    color: '#666'
  },
  pageTitle: {
    fontSize: '28px',
    fontWeight: 600,
    color: '#333'
  },
  shareButton: {
    color: '#666',
    fontSize: '14px',
    textTransform: 'none',
    fontWeight: 500,
    border: '1px solid gray',
    padding: '.4em 1em'
  },
  section: {
    marginBottom: '4em'
  },
  sectionTitle: {
    fontSize: '18px',
    fontWeight: 600,
    color: '#333',
    marginBottom: '12px'
  },
  overviewText: {
    fontSize: '14px',
    color: '#666',
    lineHeight: 1.6
  },
  sessionCard: {
    padding: '20px',
    marginBottom: '16px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    border: '1px solid #e0e0e0',
    borderRadius: '8px',
    transition: 'box-shadow 0.2s',
    '&:hover': {
      boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
    }
  },
  sessionInfo: {
    flex: 1
  },
  sessionName: {
    fontSize: '16px',
    fontWeight: 600,
    color: '#5a8a90',
    marginBottom: '6px'
  },
  sessionDescription: {
    fontSize: '13px',
    color: '#999'
  },
  hostButton: {
    width: "120px",
    backgroundColor: '#ff6b6b',
    color: 'white',
    textTransform: 'uppercase',
    fontWeight: 600,
    fontSize: '12px',
    padding: '8px 24px',
    '&:hover': {
      backgroundColor: '#ff5252'
    }
  },
    popUp: {
        width: "24rem",
        background: "#FAF9F9",
        border: '1px solid #d1d1d1',
        fontFamily:"arial",
        padding:"0",
        borderRadius:"5px",
    },

    popUpHeader:{
        margin:"1.8rem",
        fontWeight:"bold",
        fontSize:"1rem",
        color:"#4F4F4F",
    },

    popUpContent:{
        margin:"1.8rem",
    },

    field:{
        display:"block",
        background:"#FAF7EA",
        border:"1px solid #d1d1d1",
        borderRadius:"5px",
        margin:"0.5em 0 1em 0",
        padding:"0.5em 1em"
    },

    selectField:{
        fontSize: "0.875rem", 
        margin:"0.5em 0 1em 0", 
        background:"#FAF7EA", 
        borderRadius:"5px", 
        border:"1px solid #d1d1d1",
        
        padding:"0 0.5em"
    },

    popUpBtn:{
        display:"block",
        background:"#FDAF2A",
        color:"#fff",
        borderRadius:"5px",
        width:"100%",
        padding:"0.5rem 0.5rem",
        marginTop:"0.5rem",
        fontSize: "0.875rem",
        fontWeight:"bold"
    },

    popUpBtnDisabled:{
        display:"block",
        background:"#D1D1D1",
        color:"#fff",
        borderRadius:"5px",
        width:"100%",
        padding:"0.5rem 0.5rem",
        marginTop:"0.5rem",
        fontSize: "0.875rem",
        fontWeight:"bold"
    },
    modal:{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
});

class InkspireEventPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      sessions: [
        {
          id: 1,
          name: 'S1: Class Quiz',
          description: 'Decide Class based on ideal playstyle',
          link: '6943c5218617322ae4fdb016',
        },
        {
          id: 2,
          name: 'S2: Backstory Jam',
          description: 'Jam for character background & story',
          link: null,
        },
        {
          id: 3,
          name: 'S3: Ability Matchup',
          description: "Allocate points for character's ability",
          link: null,
        }
      ],

      jambuilderData: null,
      isDataReady: false,
      showPopup: false,

      name: "",
      password: "",
      passwordEnabled: false,
    };
  }

    handleCreateJam = () => {

        if (this.state.type === '' || this.state.name === ''){
            alert('Please Fill All Information!');
            return;
        }

        let creator = getUserId()
        let {name,password,jambuilderData} = this.state
        let setup = {
            createdBy: creator,
            name,
            password: password === "" ? null : password,
            team: null, /*this.state.jamSelectedTeam ? this.state.jamSelectedTeam._id : null, */
        }

        this.props.client.mutate({
            mutation: DUPLICATE_GAME,
            variables: {
                _id: jambuilderData.general.gameLink,
                setup,
                automationChange: null,
            }
        }).then((status)=>{
            // console.log(status)
            this.setState({
                name:"",
                password:"",
                passwordEnabled: false, 
                showPopup:false, 
                jambuilderData: null, 
                isDataReady:false,
            });
            // this.jbIndex = null
            window.open(`/game/${status.data.gameDuplicate._id}`)
            //window.location.reload(); // temporary for jambuilder setup
        })
    }



    handleClose = () => {
        this.setState({
            jambuilderData: null,
            isDataReady: false,
            showPopup: false,
        })
    }

    handleChange = (event) => {
        let item = event.target.name
        this.setState({
            [item]: event.target.value
        })
    }

  fetchGame = async (jid) => {
    try {
        const { data } = await this.props.client.query({
            query: GET_JAMBUILDER_BY_ID(jid),
            fetchPolicy: 'network-only'
        });
        // console.log(data)
        
        this.setState({ 
            jambuilderData: data.jamBuilderById,
            isDataReady: true 
        });
    } catch (error) {
        console.error('Error fetching data:', error);
        this.setState({ isDataReady: false, showPopup: false });
    }
  }

openPopup = () => {
    this.setState({ showPopup: true }, () => {
        if (!this.state.isDataReady) {
            this.fetchGame('6943c5218617322ae4fdb016');
        }
    });
}

// Modified popup function
popUp = (classes) => {
    // Don't render anything if showPopup is false
    if (!this.state.showPopup) return null;
    
    // Show loading while fetching data
    if (!this.state.isDataReady) {
        return (
            <Card className={classes.popUp}>
                <div className={classes.popUpContent} style={{ textAlign: 'center', padding: '40px' }}>
                    <CircularProgress />
                    <p>Loading...</p>
                </div>
            </Card>
        );
    }
    // Data is ready, show the popup content
    return (
        <Card className={classes.popUp}>
            <div className={classes.popUpHeader}>
                Host a new Jam
            </div>
            <Divider/>
            <div className={classes.popUpContent}>
                <FormControl style={{width: "100%", fontSize:"0.875rem", color:"#4F4F4F"}}>
                    <b>Jam Name *</b>
                    <p style={{color:"#828282", fontSize:"0.7rem", marginBottom:"5px"}}>Give your jam a unique name!</p>
                    <InputBase
                        className={classes.field}
                        placeholder="Example: Wayne's World"
                        name="name"
                        value={this.state.name}
                        onChange={this.handleChange}
                        inputProps={{style: {fontSize: "0.875rem", fontFamily:"arial" }, maxLength:17}}
                    />
                    
                    <div style={{color:"#4F4F4F"}}>
                        <div style={{fontSize:"0.875rem", display:"flex", alignItems:"center"}}>
                            <b>Jam Password</b>
                            
                            <div style={{marginLeft:"10px", display:"flex", alignItems:"center"}}>
                                <Switch
                                    color="primary"
                                    checked={this.state.passwordEnabled}
                                    onChange={(e) => this.setState({ passwordEnabled: e.target.checked, password: "" })}
                                />
                            </div>

                            <i style={{marginLeft:"0.2em", color:"#B8B8B8"}}>(Optional)</i>
                        </div>

                        <p style={{color:"#828282", fontSize:"0.7rem", marginBottom:"5px"}}>
                            Only those with your jam's password may view your waiting room. 
                            If none is set, anyone can view your waiting room!
                        </p>
                    </div>

                    <InputBase
                        className={classes.field}
                        type="password"
                        placeholder="password"
                        name="password"
                        value={this.state.password}
                        disabled={!this.state.passwordEnabled}
                        onChange={this.handleChange}
                        inputProps={{style: {fontSize: "0.875rem", fontFamily:"arial" }}}
                    />
                    
                    {/* <FormControl style={{width:"100%", marginTop:"15px"}}>
                        <b style={{fontSize:"0.875rem", color:"#4F4F4F"}}>Select Team</b>

                        <Select
                            value={this.state.jamSelectedTeamName}
                            onChange={(e) => {
                                if(e.target.value){
                                    this.setState({ 
                                        jamSelectedTeam: e.target.value, 
                                        jamSelectedTeamName: e.target.value.name 
                                    })
                                }else{
                                    this.setState({
                                        jamSelectedTeam: null, 
                                        jamSelectedTeamName: null 
                                    })
                                }
                            }} 
                            input={<InputBase className={classes.field} />}
                            displayEmpty
                            renderValue={(value) => {
                                if (value === null) {
                                    return <span style={{color:"#BDBDBD"}}>Without team</span>;
                                }
                                return this.state.jamSelectedTeamName
                            }}
                        >
                            <MenuItem value={null}>
                                <em>Without team</em>
                            </MenuItem>
                            {this.state.teams.map(t => (
                                <MenuItem key={t._id} value={t}>
                                    {t.name}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl> */}

                    <Button
                        onClick={this.handleCreateJam}
                        disabled={(this.state.name === '' ? true : false) || this.state.loading}
                        className={this.state.name === '' ? classes.popUpBtnDisabled : classes.popUpBtn}
                    >
                        Go to waiting room
                    </Button>
                </FormControl>
            </div>
        </Card>
    )
}

  render() {
    const { classes } = this.props;
    const { sessions } = this.state;

    return (
        <>
            <GameTopPanel/>
            <Box className={classes.root}>
            {/* Header Banner */}
            {/* <Box className={classes.headerBanner}>
            <Box className={classes.headerContent}>
                <Typography className={classes.featuredText}>
                Featured 2026 Event
                </Typography>
                <Typography className={classes.mainTitle}>
                Inkspire Showdown
                <GiftIcon className={classes.giftIcon} />
                </Typography>
            </Box>
            </Box> */}
            <Box className={classes.headerBannerOnly}>
                <img 
                    src={dndBanner} 
                    alt="Banner" 
                    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                />
            </Box>

            {/* Main Content */}
            <Container maxWidth="md" className={classes.contentContainer}>
            {/* Page Header */}
            <Box className={classes.pageHeader}>
            <Box className={classes.titleSection}>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '4px' }}>
                    <WorkshopIcon className={classes.workshopIcon} style={{ fontSize: '16px' }} />
                    <span style={{ fontSize: '12px', fontWeight: 500, color: '#666' }}>Workshop</span>
                </div>
                <Typography className={classes.pageTitle}>
                    RPG Hero’s Workshop
                </Typography>
                </div>
            </Box>
            <Button 
                className={classes.shareButton}
                startIcon={<ShareIcon />}
            >
                SHARE
            </Button>
            </Box>

            {/* Overview Section */}
            <Box className={classes.section}>
                <Typography className={classes.sectionTitle}>
                Overview
                </Typography>
                <Typography className={classes.overviewText}>
                Step into the world of adventure in this hands-on character workshop! 🏰 
                Start by discovering your character’s class and playstyle through a fun, 
                interactive card quiz. 📖 Flip Question cards, answer with your own cards, 
                and match traits to ✅ claim your class. This part helps you understand your character’s 
                role in the party and what kind of hero you want to play. ⚔️ <br/><br/>
                Next, bring your character to life by exploring personality, ideals, bonds, and flaws using prompts or cards. 
                📝 Whether you like to write or just draw inspiration from the cards, you’ll create a memorable backstory and connections with fellow players 🤝. 
                By the end of the workshop, you’ll have a fully fleshed-out, ready-to-play character with a clear identity, unique story, and hooks for adventure 🌟 
                — all in a fun, collaborative environment! 🎉
                </Typography>
            </Box>

            {/* Sessions Section */}
            <Box className={classes.section}>
                <Typography className={classes.sectionTitle}>
                Sessions
                </Typography>

                {sessions.map(session => (
                <Paper key={session.id} className={classes.sessionCard} elevation={0}>
                    <Box className={classes.sessionInfo}>
                    <Typography className={classes.sessionName}>
                        {session.name}
                    </Typography>
                    <Typography className={classes.sessionDescription}>
                        {session.description}
                    </Typography>
                    </Box>
                    <Button 
                    disabled={session.link ? false:true}
                    variant="contained" 
                    className={classes.hostButton}
                    onClick={()=>{
                        // console.log(session.link)
                        this.openPopup()
                    }}
                    >
                    {session.link ? "START" : "SCHEDULED"}
                    </Button>
                </Paper>
                ))}
            </Box>
            </Container>
            </Box>
            <Modal disableAutoFocus={true} className={classes.modal} open={this.state.showPopup} onClose={this.handleClose}>
                {this.popUp(classes)}
            </Modal>
            <FooterPanel/>
        </>

    );
  }
}

export default withApollo(withStyles(styles)(InkspireEventPage));